import { useEffect, useState } from 'react'

import Product from '@src/quince-site-common/src/domains/Product'
import { ProductOptionName } from '@src/quince-site-common/src/domains/ProductOption'
import { IProductPurchaseInfo } from '@src/quince-site-common/src/domains/ProductPurchaseInfo'
import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'
import productHelper from '@src/quince-site-common/src/helpers/productHelper'

interface UseGetOutOfStockLastChanceSizesProps {
  product: Product | undefined
  displayName: string | undefined
  productPurchaseInfo: IProductPurchaseInfo | undefined
  selectedOptions: ProductVariantOption[] | undefined
}

export const useGetOutOfStockLastChanceSizes = ({
  product,
  displayName,
  productPurchaseInfo,
  selectedOptions,
}: UseGetOutOfStockLastChanceSizesProps): string[] => {
  const [lastChanceSizes, setLastChanceSizes] = useState<string[]>([])

  useEffect(() => {
    if (product && displayName === ProductOptionName.Size && productPurchaseInfo?.svidVsSvDetails) {
      const variants = productHelper.getVariantsForOptions(
        product,
        selectedOptions?.filter(option => option.name === 'Color'),
      )
      const lastChanceVariants = variants.filter(variant => variant.lastChance === 'true')
      const outOfStockSizes = lastChanceVariants
        .filter(variant => !productPurchaseInfo.svidVsSvDetails[variant.id]?.quantityAvailable)
        .map(v => v.options.find(option => option.name === 'Size')?.value)
        .filter((size): size is string => size !== undefined)

      setLastChanceSizes(outOfStockSizes)
    }
  }, [productPurchaseInfo, product, selectedOptions, displayName])

  return lastChanceSizes
}
